// SH-1 — a right-side panel that lives in the shell's dock instead of over it.
// Children are portalled into #km-dock; the page narrows beside them. On a page
// without the shell (public, portal) the children render where they stand.
import { useEffect } from 'react';
import { createPortal } from 'react-dom';

let mounted = 0;

export default function DockPanel({ children, onClose, width }) {
  const slot = typeof document !== 'undefined' ? document.getElementById('km-dock') : null;
  const content = slot ? slot.closest('.km-shell__content') : null;

  useEffect(() => {
    if (!content) return undefined;
    mounted += 1;
    content.classList.add('has-dock');
    if (width) content.style.setProperty('--km-dock-w', width);
    return () => {
      mounted = Math.max(0, mounted - 1);
      if (mounted === 0) content.classList.remove('has-dock');
      if (width) content.style.removeProperty('--km-dock-w');
    };
  }, [content, width]);

  useEffect(() => {
    if (!onClose) return undefined;
    const esc = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', esc);
    return () => window.removeEventListener('keydown', esc);
  }, [onClose]);

  if (!slot) {
    // SH-1 — a page without the shell (Contacts, portals) has no dock, so the
    // panel keeps its own right-hand frame rather than landing in the flow.
    return (
      <div className="km-dock km-dock--loose" data-testid="km-dock-loose"
        style={width ? { width } : undefined}>{children}</div>
    );
  }
  return createPortal(children, slot);
}
